import compose from 'recompose/compose';
import { connect } from 'react-redux';
import SelectMessageType from '../components/SelectMessageType';
import { toggleSendEmail, toggleSendSms, toggleSendPush } from '../actions';
import { getShopBrandSmsOriginator, getShopBrandSmsOriginatorVerified } from '../../auth/selectors';
import { withBarberType } from '../../../modules/barber/barber-type/with-barber-type';

const SelectMessageTypeContainer = compose(
  withBarberType,
  connect(
    (state, ownProps) => ({
      sendEmailChecked: state.engagement.campaign.sendEmail,
      sendSmsChecked: state.engagement.campaign.sendSms,
      sendPushChecked: state.engagement.campaign.sendPush,
      hasSmsOriginator: !!getShopBrandSmsOriginator(state) && getShopBrandSmsOriginatorVerified(state),
      isStudioOwner: ownProps.barberType === 'studio',
    }),
    {
      toggleSendEmail,
      toggleSendSms,
      toggleSendPush,
    },
  ),
)(SelectMessageType);

export default SelectMessageTypeContainer;
